<template>

  <div class="button" @click="$emit('click')">
    <slot/>
  </div>

</template>

<script>

export default {
  name: 'Button'
}

</script>

<style lang="scss" scoped>

@import '../../styles/main-colors.scss';

  .button {
    border-radius: 1px;
    padding: 5px;
    text-align: center;
    box-shadow: 1px 1px 5px 1px mix($background-light, $background-dark, 90%);
    cursor: pointer;
  }

</style>



// WEBPACK FOOTER //
// src/components/common/Button.vue